import { useEffect } from "react";
import { APP_URL } from "../constants/constants";
import { requestInAppReview } from "../utils/inAppReview";
import { analyticsLog } from "../lib/analytics";

const AppReview:React.FC = () => {


    useEffect(() => {
        analyticsLog('test_event_3075')
        setTimeout(() => {
            requestInAppReview();
        }, 1000)
    }, [])

    return null;
}

export default AppReview